export default __webpack_public_path__ + "static/media/car2.d9e6b84c.jpg";